import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const SESSION_KEY = "innvaer-demo-session";

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = uuid();
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export const api = axios.create({ baseURL: API, timeout: 60000 });

api.interceptors.request.use((config) => {
  config.headers["X-Demo-Session"] = getSessionId();
  return config;
});

/* ------------------------------------------------------------------------
 * Example-data version watcher.
 * The backend stamps every response with X-Seed-Version. When the example data
 * set is revised while a tab is open, the server reseeds the visitor's session on
 * the next request – and we drop every cached query so the UI never shows a mix
 * of old and new data. Listeners (App shell) get notified to show a quiet toast.
 * ---------------------------------------------------------------------- */
const SEED_KEY = "innvaer-seed-version";
let queryClientRef = null;
const seedListeners = new Set();

export function registerQueryClient(qc) {
  queryClientRef = qc;
}

export function onSeedVersionChange(fn) {
  seedListeners.add(fn);
  return () => seedListeners.delete(fn);
}

api.interceptors.response.use((response) => {
  const version = response?.headers?.["x-seed-version"];
  if (version) {
    const previous = localStorage.getItem(SEED_KEY);
    if (previous && previous !== version) {
      localStorage.setItem(SEED_KEY, version);
      // Defer so the current query settles with fresh data before the rest refetches.
      setTimeout(() => {
        queryClientRef?.invalidateQueries();
        seedListeners.forEach((fn) => fn(version, previous));
      }, 0);
    } else if (!previous) {
      localStorage.setItem(SEED_KEY, version);
    }
  }
  return response;
});

export function errorMessage(err, fallback = "Noe gikk galt.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) return detail.map((d) => d.msg).join(", ");
  if (err?.code === "ECONNABORTED") return "Tidsavbrudd – prøv igjen.";
  return fallback;
}

export const fileUrl = (fileId) => `${API}/files/${fileId}`;
export const drawingUrl = (drawingId) => `${API}/drawings/${drawingId}.svg`;
